import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { sortWorkingHours } from '../../utils/working-hour.utils';
import { WorkingHour } from '../working-hour';
import { BaseManufacturingOrderBuilder } from './base-manufacturing-order.builder';
import { UserActivityBuilder } from './user-activity.builder';
import { UserSubactivityBuilder } from './user-subactivity.builder';

export class WorkingHourBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingHour(
        json.hash,
        json.userHash,
        json.userName,
        UserActivityBuilder.fromJson(json.userActivity),
        UserSubactivityBuilder.fromJson(json.userSubactivity),
        BaseManufacturingOrderBuilder.fromJson(json.manufacturingOrder),
        json.day,
        json.totalTime,
        json.editable,
        json.observation,
        json.validated,
        (json.userActivity) ? UserActivityBuilder.fromJson(json.userActivity).name : null,
        (json.userSubactivity) ? UserSubactivityBuilder.fromJson(json.userSubactivity).name : null,
        parseNumber(json.erpTask),
        json.modelHash,
        json.modelName,
        json.nonConformityCode,
        json.nonProductiveManufacturingOrderCategoryHash,
        json.nonProductiveManufacturingOrderCategoryName
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ? sortWorkingHours(mapCollection(WorkingHourBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-hour.builder.ts